import type { BtlApplication } from '@api/btlApplicationForm/types';
import { useSearchParams } from 'react-router-dom';
import { CaseApplicantIndividualPage } from './CaseApplicantIndividualPage';
import { CaseApplicantsList, OO_CREATE_INDIVIDUAL_SEARCH_PARAM } from './CaseApplicantsList';

interface CaseApplicantsPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
}

export function CaseApplicantsPage({ case: caseData, isCaseLoading }: CaseApplicantsPageProps) {
  const [searchParams] = useSearchParams();
  const individualId = searchParams.get('individualId');
  const isCreateMode = searchParams.get(OO_CREATE_INDIVIDUAL_SEARCH_PARAM) === '1';

  if (individualId || isCreateMode) {
    return (
      <CaseApplicantIndividualPage
        case={caseData}
        isCaseLoading={isCaseLoading}
        individualId={individualId}
        isCreateMode={isCreateMode}
      />
    );
  }

  return <CaseApplicantsList case={caseData} isCaseLoading={isCaseLoading} />;
}
